import { render, staticRenderFns } from "./ChatFinished.vue?vue&type=template&id=60a96d01"
import script from "./ChatFinished.vue?vue&type=script&lang=js"
export * from "./ChatFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports